var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 121,
    viewBox: "0 0 237 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.918 109.776L110.639 26.5542C107.975 24.3867 97.1921 30.2942 95.981 33.5572C91.003 46.9693 72.647 64.6026 16.6859 78.3684C13.4221 79.1713 13.3728 84.0409 16.6666 84.5593L210.445 115.053C213.481 115.531 215.278 111.696 212.918 109.776Z",
    fill: "#CEAFFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7137 81.6916C63.1944 81.1724 63.9133 80.9454 64.6044 81.0944L175.097 104.926C177.478 105.439 177.043 108.956 174.608 108.88L45.7933 104.834C44.0795 104.78 43.2261 102.736 44.3918 101.477L62.7137 81.6916Z",
    fill: "#CEAFFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5136 25.8841C37.5556 24.5267 31.768 29.9566 48.7692 41.8345C51.7791 43.9374 59.5573 47.2081 61.7914 48.9613",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2913 35.8618C62.7172 40.2736 70.1534 43.1562 73.5115 44.2108",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5876 39.2554C35.5876 39.2554 35.5876 42.9884 39.5414 46.26L41.8455 48.079C45.6402 49.8214 53.343 54.7206 55.9529 55.5451",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8652 64.3687C96.3207 69.0929 209.121 112.472 211.337 112.868",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.319 50.1152C101.544 56.428 211.859 113.173 214.074 113.764",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9782 90.8398C60.1071 91.2016 144.673 104.582 159.803 106.894",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9782 90.8398C60.1071 91.2016 144.673 104.582 159.803 106.894",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/Plane.1905adb253005b9f15d5fe2b87f99a9d.svg";
export { ForwardRef as ReactComponent };